import styled from "styled-components";
import { Flex } from "rebass/styled-components";

import { TMoment } from "MVVM/Views/MatchHistory/@types";
import { ClipBadges } from "MVVM/Components/ClipBadge";
import { TinyAvatar } from "MVVM/Views/MatchHistory/styledComponents";
import { StyledMomentIcon } from "MVVM/Views/MatchHistory/Components/Shared/Match/styledComponents";
import { ProfileCardWrapper } from "MVVM/Components/ProfileCard/Components/ProfileCardWrapper";

const MAX_VICTIMS = 4;

export const MomentSummary = ({
  moment,
  hideTitle,
}: {
  moment: TMoment;
  hideTitle?: boolean;
}) => {
  const victims = moment.victimData || [];
  const shownVictims = victims.slice(0, MAX_VICTIMS);
  const extraVictims = victims.length - shownVictims.length;
  const killIcon = moment.icons?.[0];
  const tags = moment.clipTags?.filter(
    (t) => t.key !== "CS_Round" && t.key !== "CS_Weapons",
  );

  return (
    <Row>
      <Avatars>
        {moment.player?.avatar &&
          (moment.player?.user?.username ? (
            <ProfileCardWrapper username={moment.player.user.username}>
              <TinyAvatar src={moment.player.avatar} />
            </ProfileCardWrapper>
          ) : (
            <TinyAvatar src={moment.player.avatar} />
          ))}
        {victims.length > 0 && (
          <>
            {killIcon && <KillIcon src={killIcon} />}
            <Victims>
              {shownVictims.map((v, i) => (
                <TinyAvatar
                  key={`${moment.id}-${v.gameId}-${i}`}
                  src={v.avatar}
                />
              ))}
            </Victims>
            {extraVictims > 0 && <VictimMore>+{extraVictims}</VictimMore>}
          </>
        )}
      </Avatars>
      <Meta>
        {!hideTitle && <Title>{moment.title}</Title>}
        {tags && tags.length > 0 && (
          <ClipBadges tags={tags} size="sm" maxVisible={3} />
        )}
      </Meta>
    </Row>
  );
};

const Row = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 10px;
`;

const Avatars = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 5px;
`;

const KillIcon = styled(StyledMomentIcon)`
  flex: 0 0 auto;
  height: 16px;
  width: auto;
`;

const Victims = styled(Flex)`
  align-items: center;
  flex-direction: row;

  & > * {
    margin-left: -6px;
  }
  & > *:first-child {
    margin-left: 0;
  }
`;

const VictimMore = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
`;

const Meta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Title = styled.span`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
`;
